/**
 * 查看【场次二维码】
 * @conditions 仅当页面为【详情页】qie
 * */
import React, { Component } from 'react';
import { connect } from '@souche-f2e/muji';
import { Modal } from 'antd';
import { dispatch } from '@@/store';
import styles from '../_style/index.less';
const mapStateToProps = (rootState) => ({
    session: rootState.session,
});
class LookQrCode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            pic: null,
        };
        this.onCancle = this.onCancle.bind(this);
        this.afterClose = this.afterClose.bind(this);
    }
    // desc 【展示场次二维码】弹窗
    showQrCode(pic) {
        this.setState({
            show: true,
            pic,
        });
    }
    // desc 【关闭场次二维码】弹窗
    onCancle() {
        this.setState({
            show: false,
        });
    }
    // desc 【关闭场次二维码】重置数据
    afterClose() {
        this.setState({
            pic: null,
        });
    }
    render() {
        const { pageState } = this.props.session;
        const { show, pic } = this.state;
        return pageState === 2 &&
            (<React.Fragment>
          <div className={styles.detail_header_qr} onClick={() => {
                dispatch.session.getPic((res) => {
                    this.showQrCode(res.imgPath);
                });
            }}>
            查看场次二维码
          </div>
          <Modal className={styles.detail_header_qr_modal} visible={show} title={'二维码查看'} onCancel={this.onCancle} afterClose={this.afterClose} footer={null}>
            <img src={pic}/>
          </Modal>
        </React.Fragment>);
    }
}
export default connect(mapStateToProps)(LookQrCode);
